// extracted by mini-css-extract-plugin
export default {"iframe":"oIZ8mEEsteh_lwXmBsWq"};